/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationPrivacySettingsDataSchema = z.object({
	privacyPolicyUrl: z.string().nullable(),
	organisationInformation: z.object({
		legalEntityName: z.string().nullable().optional(),
		streetAddress: z.string().nullable().optional(),
		postalCode: z.string().nullable().optional(),
		city: z.string().nullable().optional(),
		country: z.string().nullable().optional(),
		phoneNumber: z.string().nullable().optional(),
		emailAddress: z.string().email().nullable().optional(),
	}).nullable(),
	dataProtectionOfficer: z.object({
		name: z.string().nullable().optional(),
		phoneNumber: z.string().nullable().optional(),
		emailAddress: z.string().email().nullable().optional(),
	}).nullable(),
	candidateRetentionMonths: z.number().nullable(),
	autoApproveDataRemovalRequests: z.boolean(),
})

export type OrganisationPrivacySettingsDataSchema = z.infer<typeof organisationPrivacySettingsDataSchema>
